import type {EntityThumbnail, EntityThumbnailTileVariant} from '@Components/ai-chat-window/components/entity-thumbnail-tile/entity-thumbnail-tile.types';

export const MIN_TEMPLATES_TO_RENDER = 3;
export const TEMPLATES_ILLUSTRATION_ASSET = 'ai-chat-templates-for-inspiration-mobile.webp';

export interface RecommendedTemplate {
  hashedId: string;
  previewUrl: string;
  pageHashedId: string;
}

export interface TemplateThumbnail extends EntityThumbnail {
  pageHashedId: string;
}

export interface TemplatesForInspirationTileProps {
  chatId: string;
  variant: EntityThumbnailTileVariant;
}
